import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable complexity */
import React, { useMemo } from 'react';
import * as PropTypes from 'prop-types';
import ClassNames from 'classnames';
import { createUseStyles } from 'react-jss';
import A from '../A';
import { mergeStyles } from '../../utils/StyleUtils';
import withMemo from '../../decorators/withMemo';
import { useSafeCall } from '../../helpers/React';
import AccessibleHiddenText from '../AccessibleHiddenText';
import styles from './styles';
import icons from './icons';
var useStyles = createUseStyles(styles);
function Icon(props) {
  var className = props.className,
    iconClassName = props.iconClassName,
    classesProp = props.classes,
    icon = props.icon,
    color = props.color,
    link = props.link,
    route = props.route,
    routeParams = props.routeParams,
    target = props.target,
    onClick = props.onClick,
    title = props.title,
    iconProps = props.iconProps,
    alt = props.alt;
  var IconComponent = typeof icon === 'string' ? icons[icon] : icon;
  var classesComp = useStyles(props);
  var classesIcon = IconComponent == null ? void 0 : IconComponent.useStyles(props);
  var classes = useMemo(function () {
    return mergeStyles(mergeStyles(classesComp, classesIcon), classesProp);
  }, [classesComp, classesIcon, classesProp]);
  var handleClick = useSafeCall(onClick);
  var renderAsLink = /*#__PURE__*/React.createElement(A, {
    className: ClassNames(classes.container, className, color),
    onClick: handleClick,
    href: link,
    route: route,
    routeParams: routeParams,
    title: title,
    target: target,
    rel: "noreferrer"
  }, IconComponent && /*#__PURE__*/React.createElement(IconComponent, _extends({}, iconProps, {
    className: ClassNames(classes.icon, iconClassName, iconProps.className)
  })), alt && /*#__PURE__*/React.createElement(AccessibleHiddenText, {
    text: alt
  }));
  var renderDefault = /*#__PURE__*/React.createElement("span", {
    className: ClassNames(classes.container, className, color),
    onClick: handleClick,
    role: "presentation"
  }, IconComponent && /*#__PURE__*/React.createElement(IconComponent, _extends({}, iconProps, {
    className: ClassNames(classes.icon, iconClassName, iconProps.className)
  })), alt && /*#__PURE__*/React.createElement(AccessibleHiddenText, {
    text: alt
  }));
  return link || route ? renderAsLink : renderDefault;
}
Icon.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf(Object.keys(icons))]).isRequired,
  color: PropTypes.string,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  iconProps: PropTypes.shape({
    className: PropTypes.string
  }),
  onClick: PropTypes.func,
  link: PropTypes.string,
  route: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  routeParams: PropTypes.object,
  target: PropTypes.string,
  title: PropTypes.string,
  alt: PropTypes.string
};
Icon.defaultProps = {
  classes: null,
  color: null,
  iconClassName: null,
  className: null,
  onClick: function onClick() {
    return undefined;
  },
  link: null,
  route: null,
  routeParams: null,
  target: null,
  title: null,
  alt: null,
  iconProps: {
    className: null
  }
};
export default withMemo()(Icon);